// reingreso-evaluado.js
//
// «Evaluar el reingreso UNA vez por carga de la app» (#1738 R22, R24). El reingreso de una cuenta
// que ya usa la app (`reingreso_faltante` de /me) se muestra al entrar, antes del Turno; pero
// `/me` se refresca durante la sesión (al cerrar un gate, al guardar algo, al volver a la pestaña)
// y NO puede sacar a nadie del Turno a mitad de trabajo: eso es perder el hilo de un médico en
// turno. Por eso la decisión se toma una sola vez y se recuerda aquí.
//
// El flag vive en MEMORIA del módulo y no en sessionStorage a propósito: se reinicia con cada carga
// de la página, que es justo lo que pide R24 («se vuelve a evaluar en la próxima carga»);
// sessionStorage sobreviviría a un F5 y la cuenta no volvería a verlo en toda la pestaña. El
// try/catch queda por si un navegador con el almacenamiento bloqueado rompe la lectura del espejo
// que se deja para depurar (`__reingreso_evaluado`), que nunca decide nada.
// Cubre R22 y R24 — .claude/specs/1738-etapa-alta/
let evaluado = false;

export const reingresoYaEvaluado = () => evaluado;

export const marcarReingresoEvaluado = () => {
  evaluado = true;
  try {
    window.sessionStorage.setItem("__reingreso_evaluado", "1");
  } catch (_) {
    /* almacenamiento bloqueado: el flag en memoria alcanza */
  }
};

// Solo para los tests.
export const reiniciarReingresoEvaluado = () => {
  evaluado = false;
  try {
    window.sessionStorage.removeItem("__reingreso_evaluado");
  } catch (_) {
    /* igual */
  }
};
